<template style="height: 100%;">
  <div class="Usermodify">
    <h2>密码修改</h2>
    <el-form :model="ruleForm"  ref="ruleForm"  label-width="100px" class="demo-ruleForm" :rules="rules" >
      <el-form-item label="原始密码:" prop="lpass">
        <el-input  type="password"
          v-model="ruleForm.lpass"
          placeholder="请输入原密码"
          maxlength="20"
        ></el-input>
      </el-form-item>
      <el-form-item label="新密码:" prop="newpass">
        <el-input type="password"
          v-model="ruleForm.newpass"
          placeholder="请输入新密码(8至20位，包含数字、英文字母)"
          maxlength="20"
        ></el-input>
      </el-form-item>
      <el-form-item label="确认密码:" prop="newpass2">
        <el-input type="password"
          v-model="ruleForm.newpass2"
          placeholder="请再次输入密码(8至20位，包含数字、英文字母)"
          maxlength="20"
        ></el-input>
      </el-form-item>
    </el-form>
    <el-button @click="tj('ruleForm')" style="margin-left: 49%;" type="primary">
      保存
    </el-button>
  </div>
</template>
<script>
export default {
  data() {
    return {
      ruleForm: {
        lpass: '',
        newpass: '',
        newpass2: '',
      },
      rules: {
        lpass: [
          {
            required: true,

            message: '请输入原始密码!',
            trigger: 'blur',
          },
        ],
        newpass: [
          {
            required: true,
            // pattern: /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{8,}$/,
            pattern: /(?!\d+$)(?!^[a-zA-Z]+$)(?!^[_#@]+$).{8,20}/,

            message: '8至20位，包含数字、英文字母',
            trigger: 'blur',
          },
        ],
        newpass2: [
          {
            required: true,
            // pattern: /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{8,}$/,
            pattern: /(?!\d+$)(?!^[a-zA-Z]+$)(?!^[_#@]+$).{8,20}/,

            message: '8至20位，包含数字、英文字母',
            trigger: 'blur',
          },
        ],
      },
    }
  },

  methods: {
    tj(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$Http_Post('User/GetChangePassword',
             {
              FistPwd: this.ruleForm.newpass,
              LastPwd: this.ruleForm.newpass2,
              Pwd: this.ruleForm.lpass,
            },
          ).then((res) => {
            if (res.Code == 200 || res.Code == 0) {
              this.Global.request_successful(res.Message)
              sessionStorage.removeItem('username')
              this.$router.push('/login')
            } else {
              this.Global.request_failure(res.Message)
            }
          })

        } else {
          this.Global.request_failure("信息填写有误!")
          return false;
        }
      });




    },
  },
}
</script>
<style>
.Usermodify h2 {
  font-size: 24px;
  text-align: center;
  margin-top: 100px;
}
.Usermodify .demo-ruleForm {
  width: 450px;
  margin: auto;
  margin-top: 50px;
}
.Usermodify .is-required{
  margin-top: 20px;
}
.Usermodify button{margin-top: 20px;}
</style>